import { FC, SVGProps } from "react";

const ProfileIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentcolor" {...props}>
      <path
        d="M15.2877 8.16346C15.2877 9.97963 13.8155 11.4519 11.9993 11.4519C10.1831 11.4519 8.71082 9.97963 8.71082 8.16346C8.71082 6.34729 10.1831 4.875 11.9993 4.875C13.8155 4.875 15.2877 6.34729 15.2877 8.16346Z"
      />
      <path
        d="M11.9993 19.125C15.2568 19.125 17.1335 18.2848 18.0041 17.7439C18.4115 17.4909 18.6123 17.0249 18.5709 16.5422C18.5143 15.883 18.284 15.2246 18.0494 14.7023C17.7415 14.0166 17.0287 13.6442 16.277 13.6442H7.72156C6.96988 13.6442 6.25708 14.0166 5.94915 14.7023C5.71462 15.2245 5.48428 15.883 5.4277 16.5422C5.38627 17.0249 5.58706 17.4909 5.99444 17.7439C6.86504 18.2848 8.74181 19.125 11.9993 19.125Z"
      />
    </svg>
  );
};

export default ProfileIcon;
